<template>
    <div class="popup rd-dialog rd-pay-info" :class="classObj">
        <van-popup v-model="show" @click-overlay="close">
            <div class="icon-close" @click="close">
                <i class="iconfont icon-s-cuowu-guanbi"></i>
            </div>
            <div class="content">
                <div class="header">
                    <div class="title">
                        <div class="img">
                            <img src="@/assets/deposit/newDeposit.png" />
                        </div>
                        <div>{{ $t("deposit.information") }}</div>
                    </div>
                    <!-- <div class="desc">{{ $t("deposit.DepositTips") }}</div> -->
                </div>
                <div class="main-content">
                    <div class="descBar">{{ $t("deposit.TransferAmount") }} <span class="importVal" @click="onCopy(amount)">{{ amount
                            }}</span>
                        <br />
                        {{ $t("deposit.TargetAccount") }} <span class="importVal" @click="onCopy(mobileNumber)">{{ mobileNumber
                            }}</span>
                        <br />
                        {{ $t("deposit.name") }} <span class="importVal" @click="onCopy(PayeeName)">{{ PayeeName
                            }}</span>
                        <br />
                        {{ $t("deposit.bank") }} <span class="importVal" @click="onCopy(bankName)">{{ bankName
                            }}</span>
                        <br />
                        {{ $t("deposit.showTips") }}
                    </div>
                    <div class="btn" @click="close">{{ $t("deposit.transferred") }}</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getUrlMsg } from '@/api/deposit'
export default {
    name: 'payDetail',
    data() {
        return {
            show: false,
            amount: '500',
            mobileNumber: '123456789',
            PayeeName: 'Зульфа Султанов Рафисович',
            bankName: 'А-Мобайл'
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        }
    },
    created() {
        this.amount = 250
    },
    methods: {
        close() {
            this.show = false
        },
        setMsg(val) {
            getUrlMsg({ getUrl: val }).then(res => {
                this.amount = res.payment.amount / 100
                this.mobileNumber = res.sbp.phone
                this.PayeeName = res.sbp.name
                this.bankName = res.sbp.bank
                this.open()
            })
        },
        // async getUrlMsg(url) {
        //     try {
        //         const response = await fetch(url)
        //         const data = await response.json()
        //         // console.log('data: ', data)
        //         this.amount = data.payment.amount / 100
        //         this.mobileNumber = data.sbp.phone
        //         this.PayeeName = data.sbp.name
        //         this.bankName = data.sbp.bank
        //         this.open()
        //     } catch (error) {
        //         console.error('fail:', error)
        //     }
        // },
        open() {
            this.show = true
        }
    }
}
</script>

<style scoped lang="scss">
    @import '@/common/styles/viriables.scss';

$deposit-paydetail-close-bg: rgba($bg-shell-color, .4);
$deposit-paydetail-panel-bg: $bg-home-popup-shell-color;
$deposit-paydetail-header-bg: linear-gradient(90deg, rgba($font-component-cool-color, .88) 0%, rgba($font-component-gold-soft-color, .92) 100%);
$deposit-paydetail-desc-bg: rgba($font-label-color, .6);
$deposit-paydetail-desc-text: $font-btn-color;
$deposit-paydetail-link-color: $font-component-danger-strong-color;
$deposit-paydetail-button-text: $font-btn-color;
$deposit-paydetail-button-bg: $bg-component-reward-chip-color;
$deposit-paydetail-table-border: $border-component-input-focus-color;
$deposit-paydetail-table-header-bg: $bg-component-button-color;
$deposit-paydetail-table-header-text: $font-component-gold-base-color;
$deposit-paydetail-heading-text: $font-btn-color;
$deposit-paydetail-step-gradient: linear-gradient(180deg, $font-accent-color 0%, $font-component-gold-base-color 50%, $font-component-gold-warm-color 100%);
.popup {
    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .icon-close {
            width: 28px;
            height: 28px;
            background: $deposit-paydetail-close-bg;
            border-radius: 50px;
            font-weight: 700;
            box-sizing: border-box;
            position: absolute;
            top: 10px;
            right: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2;
            cursor: pointer;

            &>i {
                color: $font-color;
                font-size: .22rem;
                vertical-align: middle;
            }
        }

        .content {
            border-radius: 12px;
            background-color: $deposit-paydetail-panel-bg;
            width: 500px;
            max-height: 80vh;
            height: 700px;
            box-sizing: border-box;
            position: relative;
            overflow: auto;
            padding-bottom: 30px;
        }

        .header {
            height: 118px;
            background: $deposit-paydetail-header-bg;
            width: 100%;
            border-radius: 12px 12px 0 0;
            overflow: hidden;

            .title {
                height: 110px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-size: 24px;
                color: $font-component-focus-alpha-color;
                font-weight: bold;

                &>.img {
                    width: 110px;
                    height: 100px;
                    padding: 15px;
                    margin-right: 15px;

                    &>img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .desc {
                background-color: $deposit-paydetail-desc-bg;
                border-radius: 10px;
                margin: 0 12px;
                // margin-top: 15px;
                height: 130px;
                padding: 20px 2%;
                text-align: center;
                font-size: .28rem;
                color: $deposit-paydetail-desc-text;
            }
        }

        .main-content {
            padding: 0 .28rem;

            .importVal {
                color: $deposit-paydetail-link-color;
                text-decoration: underline;
            }

            .descBar {
                color: $bg-component-input-focus-color;
                font-size: 24px;
                margin-top: 50px;
                text-align: left;
            }

            .btn {
                display: block;
                width: 90%;
                margin: 4% auto 7%;
                line-height: 40px;
                font-size: 14px;
                margin-top: 20px;
                font-weight: bold;
                color: $deposit-paydetail-button-text;
                text-align: center;
                text-decoration: none;
                background: $deposit-paydetail-button-bg;
                border-radius: 5px;
                box-sizing: border-box;
            }

            .table {
                width: 100%;
                border: .01rem solid $deposit-paydetail-table-border;
                margin-bottom: .2rem;

                .table-header {
                    background: $deposit-paydetail-table-header-bg;
                    color: $deposit-paydetail-table-header-text;
                    text-align: center;
                    width: 100%;
                    display: flex;
                    align-items: center;

                    &>div:first-child {
                        height: 100%;
                        width: 70%;
                        padding: 10px;
                    }

                    &>div:last-child {
                        height: 100%;
                        width: 30%;
                        padding: 10px;
                    }
                }

                .table-body {
                    width: 100%;

                    &>.tr {
                        display: flex;
                        align-items: center;
                        border-bottom: .01rem solid $deposit-paydetail-table-border;

                        &>div:first-child {
                            height: 100%;
                            width: 70%;
                            border-right: .01rem solid $deposit-paydetail-table-border;
                            padding: 10px;
                        }

                        &>div:last-child {
                            height: 100%;
                            width: 30%;
                            padding: 10px;
                        }

                        &:last-child {
                            border-bottom: none;
                        }
                    }
                }
            }

            .how {
                padding-bottom: 38px;

                .how-title {
                    font-weight: bold;
                    padding: 5px 2%;
                    text-align: center;
                    box-sizing: border-box;
                    color: $deposit-paydetail-desc-text;
                }

                .how-step {
                    font-weight: bold;
                    background: $deposit-paydetail-step-gradient;
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    text-align: center;
                    margin: 10% 0px 6% 0px;
                }

                &>img {
                    box-sizing: border-box;
                    height: auto;
                    max-width: 100%;
                }

                .how-tips {
                    font-weight: bold;
                    padding: 0px 2%;
                    text-align: center;
                    color: $deposit-paydetail-desc-text;
                }
            }
        }

    }

    &.mobile {
        // width: 100% !important;
        // height: 100% !important;

        .van-popup {
            &.van-popup--center {
                top: 16vh;
                bottom: 0;
                left: 0;
                transform: translate3d(0, 0, 0);
                width: 100% !important;
                // height: 100% !important;
            }
        }

        .content {
            width: 100% !important;
            height: 100% !important;
            max-height: 100%;
            border-radius: 12px 12px 0 0 !important;
        }
    }
}
</style>
